import React, { useContext } from 'react';
import { string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { RecentOrders as RecentOrdersComponent } from '@thd-olt-component-react/recent-order-details';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { HomepageContext } from './context/HomepageContext';
import { getHydrationOptions } from '../utils/constants';

export function RecentOrders({ id }) {
  const { isConsumerApp, channel } = useContext(ExperienceContext);
  const { isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="recent-orders">
      <QueryProvider cachekey="recent-orders">
        <Hydrator
          placeholder={getHydrationOptions(channel, isConsumerApp).PLACEHOLDER_SECTION}
          delay={isConsumerApp && 5000}
          className="sui-h-full"
          id="recent-orders-hydrator"
        >
          <RecentOrdersComponent
            componentId={id}
            enableB2CBorderRadius={isB2C}
          />
        </Hydrator>
      </QueryProvider>
    </ErrorBoundary>
  );
}

RecentOrders.propTypes = {
  id: string,
};

RecentOrders.defaultProps = {
  id: undefined,
};